import './index.less'

import { Icon, Menu, Dropdown } from 'ant-design-vue'
import i18nMixin from '@/store/i18n-mixin'

const locales = ['zh-CN', 'ja-JP']
const languageLabels = {
  'zh-CN': '简体中文',
  'ja-JP': '日本語'
}
// eslint-disable-next-line
const languageIcons = {
  'zh-CN': '🇨🇳',
  'ja-JP': '🇯🇵'
}

const SelectLang = {
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-drop-down'
    }
  },
  name: 'SelectLang',
  mixins: [i18nMixin],
  render () {
    const { prefixCls } = this
    const changeLang = ({ key }) => {
      this.setLang(key)
    }
    const langMenu = (
      <Menu class={['menu', 'ant-pro-header-menu']} selectedKeys={[this.currentLang]} onClick={changeLang}>
        {locales.map(locale => (
          <Menu.Item key={locale}>
            <span role="img" aria-label={languageLabels[locale]}>
              {languageIcons[locale]}
            </span>{' '}
            {languageLabels[locale]}
          </Menu.Item>
        ))}
      </Menu>
    )
    return (
      <Dropdown overlay={langMenu} placement="bottomRight">
        <a-button type="link" class={prefixCls} aria-label={this.$tt('切换语言')}>
          <Icon type="global" title={this.$tt('切换语言')} />
        </a-button>
      </Dropdown>
    )
  }
}

export default SelectLang
